export const dasherize = (str) => str
    .replaceAll(/([A-Z]($|[a-z]))/g, "-$1")
    .replaceAll("--", "-")
    .replace(/^-|-$/, "")
    .toLowerCase();
/**
 * Decorator that registers a custom element.
 *
 * The convention is to use PascalCase for the class name suffixed with Element.
 * This decorator will convert the class name to kebab-case and strip the `-element` suffix.
 *
 * Note: This requires class names to not be minified. With webpack, this can be achieved by
 * setting `keep_classnames: true` or `keep_classnames: /Element$/` in the TerserPlugin options.
 *
 * @example
 * ShowPasswordElement -> show-password
*/
export function customElement(classObject) {
    const name = dasherize(classObject.name).replace(/-element$/, "");
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window[classObject.name] = classObject;
        globalThis.customElements.define(name, classObject);
    }
    catch (error) {
        if (!(error instanceof DOMException && error.name === "NotSupportedError")) {
            throw error;
        }
    }
}
